import { render } from "./hr-short-answer-questions.vue?vue&type=template&id=90c755ac&scoped=true"
import script from "./hr-short-answer-questions.vue?vue&type=script&lang=js"
export * from "./hr-short-answer-questions.vue?vue&type=script&lang=js"

import "./hr-short-answer-questions.vue?vue&type=style&index=0&id=90c755ac&scoped=true&lang=css"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90c755ac"]])

export default __exports__